<script setup lang="ts">
import { UIcon } from "#components";
import type { Language } from "~/typings/database.d";

type Props = {
  languages: Language[];
};

defineProps<Props>();
</script>
<template>
  <div>
    <div class="mb-8">
      <UiTitle level="3" class="text-3xl font-semibold mb-4">
        Languages
      </UiTitle>
    </div>
    <ul class="space-y-6">
      <li
        v-for="lang in languages"
        :key="lang.name"
        class="flex justify-between items-center"
      >
        <div class="flex items-center text-sm gap-x-2 text-gray-500">
          <UIcon :name="lang.icon" size="16" />
          <div class="flex gap-x-2 lg:gap-x-4">
            <UiParagraph class="font-semibold">{{ lang.name }}</UiParagraph>
            <UiParagraph class="font-light italic opacity-75">{{
              lang.proficiency
            }}</UiParagraph>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
